import { Transform, Type } from 'class-transformer';
import { dateTransform } from '../utils/helpers';

export class Giornata {
    docenti!: string[];
    @Transform(dateTransform)
    fine!: Date;
    @Transform(dateTransform)
    inizio!: Date;
    programma!: string;
}

export const DATE_FROM_NULL = 321195049;
export const DATE_TO_NULL = 7263694249;

export class Attivita {
    // allegati!: any[];
    @Transform(dateTransform)
    aperturaIscrizioni!: Date;
    cfp!: number;
    @Transform(dateTransform)
    chiusuraIscrizioni!: Date;
    comune!: string;
    costoCent!: number;
    descrizione!: string;
    @Type(() => Giornata)
    giornate!: Giornata[];
    id!: number;
    indirizzo!: string;
    luogo!: string;
    oreDurata!: number;
    oreFrequenzaMinima!: number;
    organizzatore!: string;
    postiDisponibili!: number;
    postiRimanenti!: number;
    provincia!: string;
    regione!: string;
    responsabile!: string;
    settore!: string;
    tipo!: string;
    titolo!: string;
}


export class AttivitaRequest {
    iniziodal!: number | undefined;
    inizioal!: number | undefined;
    finedal!: number | undefined;
    fineal!: number | undefined;
    titolo!: string;
    settore!: string;
    pagamento!: number;
}
